var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.707,
    height: 15.707,
    viewBox: "0 0 15.707 15.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85421",
    "data-name": "Group 85421",
    transform: "translate(-685.146 -473.146)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1398",
    "data-name": "Line 1398",
    y2: 21.213,
    transform: "translate(685.5 473.5) rotate(-45)",
    fill: "none",
    stroke: "#3f4145",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1399",
    "data-name": "Line 1399",
    y2: 21.213,
    transform: "translate(700.5 473.5) rotate(45)",
    fill: "none",
    stroke: "#3f4145",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.d1dcbc233e16675a9adab78a54ba014b.svg";
export { ForwardRef as ReactComponent };